"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createItemsAvailabilityRequest = void 0;

var frontend_common_1 = require("@ryerson/frontend.common");

var createItemsAvailabilityRequest = function createItemsAvailabilityRequest(matchingProducts, isLoggedIn, selectedAddress, defaultShipToAddress, customerPickup, salesPlant, zipCode, availabilityLineItem, profile) {
  var shipToAddress;
  var shippingPlant;
  var shipToNumber;

  if (isLoggedIn) {
    if (customerPickup) {
      shipToAddress = defaultShipToAddress;
      shippingPlant = defaultShipToAddress === null || defaultShipToAddress === void 0 ? void 0 : defaultShipToAddress.shippingPlant;
      shipToNumber = defaultShipToAddress.shipToNumber;
    } else {
      shipToAddress = (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.zipCode) ? selectedAddress : salesPlant;
      shippingPlant = selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.shippingPlant;
      shipToNumber = selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.shipToNumber;
    }
  } else {
    shipToAddress = salesPlant;
    shippingPlant = salesPlant.sapPlantNumber || "";
  }

  return Object.assign(Object.assign({
    currency: frontend_common_1.CurrencyCode.us
  }, !isLoggedIn && {
    zipCode: zipCode
  }), {
    shippingType: customerPickup ? frontend_common_1.ShippingType.customerPickup : frontend_common_1.ShippingType.standard,
    couponCode: "",
    lineItems: matchingProducts === null || matchingProducts === void 0 ? void 0 : matchingProducts.map(function (item, index) {
      var _ref = (0, frontend_common_1.getUsersDefaultUomValue)(item, profile),
          defaultQtyUom = _ref.defaultQtyUom,
          defaultPricingUom = _ref.defaultPricingUom;

      var quantityUom = (availabilityLineItem === null || availabilityLineItem === void 0 ? void 0 : availabilityLineItem.quantityUom) ? availabilityLineItem === null || availabilityLineItem === void 0 ? void 0 : availabilityLineItem.quantityUom : defaultQtyUom;
      var pricingUom = (availabilityLineItem === null || availabilityLineItem === void 0 ? void 0 : availabilityLineItem.pricingUom) ? availabilityLineItem === null || availabilityLineItem === void 0 ? void 0 : availabilityLineItem.pricingUom : defaultPricingUom;

      var _ref2 = (0, frontend_common_1.getCorrectQuantityAndWeightOfProduct)(item, (availabilityLineItem === null || availabilityLineItem === void 0 ? void 0 : availabilityLineItem.quantity) ? availabilityLineItem === null || availabilityLineItem === void 0 ? void 0 : availabilityLineItem.quantity : 0, quantityUom, pricingUom),
          updatedQuantity = _ref2.updatedQuantity;

      var updatedQty = Math.floor(Number(updatedQuantity));
      return {
        itemNumber: index + 1,
        comboKey: item === null || item === void 0 ? void 0 : item.comboKey,
        materialSku: item === null || item === void 0 ? void 0 : item.materialMaster,
        customerPartNo: (0, frontend_common_1.getCustomerPartNumber)(item === null || item === void 0 ? void 0 : item.altPartNumber),
        quantity: updatedQty,
        quantityUom: quantityUom,
        pricingUom: pricingUom
      };
    }),
    partners: {
      shipTo: {
        shippingPlant: shippingPlant,
        addressLine1: isLoggedIn && (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.zipCode) && !customerPickup ? selectedAddress.address1 : salesPlant.street,
        city: shipToAddress === null || shipToAddress === void 0 ? void 0 : shipToAddress.city,
        state: shipToAddress === null || shipToAddress === void 0 ? void 0 : shipToAddress.state,
        zipCode: (0, frontend_common_1.formatZipCode)((shipToAddress === null || shipToAddress === void 0 ? void 0 : shipToAddress.zipCode) || zipCode),
        country: shipToAddress === null || shipToAddress === void 0 ? void 0 : shipToAddress.country,
        id: shipToAddress === null || shipToAddress === void 0 ? void 0 : shipToAddress.id,
        shipToNumber: isLoggedIn && shipToNumber
      }
    }
  });
};

exports.createItemsAvailabilityRequest = createItemsAvailabilityRequest;